import { render } from "./List.vue?vue&type=template&id=2ab4199a&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=2ab4199a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ab4199a"

export default script